// --- src/pages/ListingDetails.js ---
import React from "react";
import { useParams } from "react-router-dom";
import listings from "../data/listings";

const ListingDetails = () => {
  const { id } = useParams();
  const listing = listings.find((l) => l.id === parseInt(id));

  if (!listing) return <p className="text-center mt-10">Listing not found.</p>;

  return (
    <div className="p-6 md:p-20">
      <img
        src={listing.image}
        alt={listing.title}
        className="w-full h-80 object-cover rounded mb-6"
      />
      <h1 className="text-3xl font-bold mb-2">{listing.title}</h1>
      <p className="text-gray-600 mb-4">{listing.location}</p>
      <p className="text-xl text-blue-900 font-semibold mb-6">
        ${listing.price}
      </p>
      <p>
        {listing.description ||
          "Detailed information about the property will go here."}
      </p>
    </div>
  );
};

export default ListingDetails;
